import disciplines from 'leverade-disciplines-i18n/i18n/es'
import { activities } from '@/src/server/i18n/es/activities'

export default {
  activities,
  disciplines,

  empty: 'No hay datos para mostrar',
  event_list: 'Listado de eventos',
  filter_select_default: 'Quitar filtro',
  filter_select_default_active: 'Filtrar por...',
  photo: '{count} foto | {count} fotos',
  postponed: 'Aplazado',
  rest: 'Descansa',
  view_calendar: 'Ver calendario',
}



// WEBPACK FOOTER //
// ./src/server/i18n/es/index.js